import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUserInformation } from './actions/userAuth';

// Importing pages
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Faq from './pages/Faq';
import JobPost from './pages/JobPost';
import JobStatus from './pages/JobStatus';
import CandidateApplicants from './pages/CandidateApplicants';

// Importing components
import Profile from './pages/Profile';
import CoachDashboard from './components/Coach/CoachDashboard';
import EmployerDashboard from './components/Employer/EmployerDashboard';
import CreateProfile from './components/Coach/Profile/CreateProfile';
import CandidateProfile from './components/Candidate/Profile/CandidateProfile';
import CandidateDashboard from './components/Candidate/Profile/CandidateDashboard';
import JobPreview from './components/Employer/JobPreview';
import JobView from './components/Employer/JobView';
import RecommandedJob from './components/Candidate/RecommandedJob';
import AppliedJobs from './components/Candidate/AppliedJobs';
import DreamJob from './components/Candidate/DreamJob';
import ApplicantsPreview from './pages/ApplicantsPreview';
import AllApplications from './pages/AllApplications';
import JobDraft from './pages/JobDraft';
import DreamJobDetails from './components/Candidate/DreamJobDetails';
import CoachAvailablity from './components/Coach/CoachAvailablity';
import EditJob from './pages/EditJob';
import CreateAvailability from './pages/CreateAvailablity';
import EditAvailability from './pages/EditAvailability';
import AddServices from './components/Coach/AddServices';
import PreviewService from './components/Coach/PreviewService';
import CoachServicesStatus from './components/Coach/CoachServicesStatus';
import CoachTraining from './components/Coach/CoachTraining';
import ServicesStatus from './components/Coach/ServicesStatus';
import EditServices from './components/Coach/EditServices';
import ServiceSessionDetails from './pages/ServiceSessionDetails';
import CoachUpcomingServiceSessions from './components/Coach/CoachUpcomingServiceSessions';
import ActiveCandidateDetails from './components/Coach/ActiveCandidateDetail';
import ServiceSessionsDetail from './components/Coach/ServiceSessionsDetail';
import FindJobs from './pages/FindJobs';
import CandidateServices from './pages/CandidateServces';
import CoachDetail from './components/Candidate/CoachDetail';
import RecommendedCoach from './components/Candidate/RecommendedCoach';
import FeaturedService from './components/Candidate/FeaturedService';
import ServiceDetails from './components/Candidate/ServiceDetails';
import ServiceDetails2 from './components/Candidate/ServiceDetails2';
import CandidateServiceOrderDetailPage from './pages/CandidateServiceOrderDetailPage';
import CandidateManageService from './components/Candidate/CandidateManageService';
import CandidateUpcomingService from './components/Candidate/CandidateUpcomingService';
import CandidateOrderHistory from './components/Candidate/CandidateOrderHistory';
import BrowseCoaches from './pages/BrowseCoaches';
import Appplicants from './pages/Appplicants';
import RescheduleService from './components/Candidate/RescheduleService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import ApplicationDetail from './components/Employer/ApplicationDetail';
import EmployerProfile from './components/Employer/EmployerProfile';
import FavouriteCandidate from './components/Employer/FavouriteCandidate';
import EmployerCandidates from './components/Employer/EmployerCandidates';
import EmployerCandidateProfile from './components/Employer/EmployerCandidateProfile';
import CurrentPackage from './components/Employer/CurrentPackage';
import EmailTemplate from '../src/components/Employer/EmailTemplate';
import EmailTemplateCoach from '../src/components/Coach/EmailTemplate';
import History from './components/Employer/History';
import ServiceHistory from './components/Coach/ServiceHistory';
import Wallet from './components/Coach/Wallet';
import WalletDetail from './components/Coach/WalletDetail';
import CreateInvoice from './components/Coach/CreateInvoice';
import Packages from './components/Coach/Packages';
function App() {
  const dispatch = useDispatch();

  // Removing refresh token and remember me from local storage on beforeunload event
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (localStorage.getItem("rememberMe")) {
        var temp = localStorage.getItem("rememberMe");
        if (temp !== 'true') {
          if (localStorage.getItem("refreshToken")) {
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("rememberMe");
          }
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Getting user information from server using refresh token
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      dispatch(getUserInformation({}, (data) => {
        dispatch({
          type: "LOG_IN",
          payload: data.data.data,
        });
        localStorage.setItem("user", JSON.stringify(data.data.data));
      }, (err) => {
        console.log(err);
      }, localStorage.getItem("refreshToken")
      ))
    }
  }, [])

  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Profile */}
          <Route path="/profile" element={<Profile />} />

          {/* Coach */}
          <Route path="/coach">
            <Route path="create-profile" element={<CreateProfile />} />
            <Route path="dashboard" element={<CoachDashboard />} />
            <Route path="edit-availibility" element={<CoachAvailablity />} />
            <Route path="edit-availibility/:id" element={<EditAvailability />} />
            <Route path="add-availibility" element={<CreateAvailability />} />
            <Route path="add-services" element={<AddServices />} />
            <Route path="preview-service" element={<PreviewService />} />
            <Route path="services-status" element={<CoachServicesStatus />} />
            <Route path="service-history" element={<ServiceHistory />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="wallet-detail" element={<WalletDetail/>} />
            <Route path="create-invoice" element={<CreateInvoice/>} />
            <Route path="packages" element={<Packages/>} />
            <Route path="training" element={<CoachTraining />} />
            <Route path="services-status/:id" element={<ServicesStatus />} />
            <Route path="edit-services/:id" element={<EditServices />} />
            <Route path="session-details" element={<ServiceSessionDetails />} />
            <Route path="upcoming-sessions" element={<CoachUpcomingServiceSessions />} />
            <Route path="active-candidate-details" element={<ActiveCandidateDetails />} />
            <Route path="service-sessions-details" element={<ServiceSessionsDetail />} />
            <Route path="emails" element={<EmailTemplateCoach />} />
          </Route>

          {/* Candidate */}
          <Route path="/candidate">
            <Route path="create-profile" element={<CandidateProfile />} />
            <Route path="dashboard" element={<CandidateDashboard />} />
            <Route path="recommanded-jobs" element={<RecommandedJob />} />
            <Route path="applied-jobs" element={<AppliedJobs />} />
            <Route path="manage-Service" element={<CandidateManageService />} />
            <Route path="upcoming-Service" element={<CandidateUpcomingService />} />
            <Route path="order-history" element={<CandidateOrderHistory />} />
            <Route path="browse-jobs" element={<DreamJob />} />
            <Route path="job-view/:id" element={<DreamJobDetails />} />
            <Route path="candidate-service" element={<CandidateServices />} />
            <Route path="coach-detail/:id" element={<CoachDetail />} />
            <Route path="recommended-coach" element={<RecommendedCoach />} />
            <Route path="featured-service/:id" element={<FeaturedService />} />
            <Route path="service-details/:id" element={<ServiceDetails />} />
            <Route path="service-details2/:id" element={<ServiceDetails2 />} />
            <Route path="candidate-service-purchase/:id" element={<CandidateServiceOrderDetailPage />} />
            <Route path="browse-coach" element={<BrowseCoaches />} />
            <Route path="reschedule-service" element={<RescheduleService />} />
          </Route>

          {/* Employer */}
          <Route path="/employer">
            <Route path="dashboard" element={<EmployerDashboard />} />
            <Route path="job-post" element={<JobPost />} />
            <Route path="job-status" element={<JobStatus />} />
            <Route path="job-preview" element={<JobPreview />} />
            <Route path="job-draft" element={<JobDraft />} />
            <Route path="job-view" element={<JobView />} />
            <Route path="candidate/applicants" element={<CandidateApplicants />} />
            <Route path="candidates" element={<EmployerCandidates />} />
            <Route path="candidates/employer-candidate-profile" element={<EmployerCandidateProfile />} />
            <Route path="candidate/favourite" element={<FavouriteCandidate />} />
            <Route path="applicant-preview" element={<ApplicantsPreview />} />
            <Route path="all-applications" element={<AllApplications />} />
            <Route path="edit-job/:id" element={<EditJob />} />
            <Route path="applicants" element={<Appplicants />} />
            <Route path="application-details" element={<ApplicationDetail />} />
            <Route path="profile" element={<EmployerProfile />} />
            <Route path="packages/current-package" element={<CurrentPackage />} />
            <Route path="emails" element={<EmailTemplate />} />
            <Route path="history" element={<History />} />
          </Route>

          {/* Other Pages */}
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/job-details/:id" element={<JobView />} />
          <Route path="/find-jobs" element={<FindJobs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-condition" element={<TermsConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />

        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
